module.exports = __webpack_public_path__ + "static/whoIs-2a867d19de78e630cf0908cb27fe1fe6.jpg";